export enum DropMode {
  CHAT = "CHAT",
  PARTICIPATION = "PARTICIPATION",
  BOTH = "BOTH",
}

export type CurationComposerVariant = "default" | "leaderboard";
